import { render, staticRenderFns } from "./ModalVisualizarDados.vue?vue&type=template&id=7ec204e1&scoped=true"
import script from "./ModalVisualizarDados.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalVisualizarDados.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ModalVisualizarDados.vue?vue&type=style&index=0&id=7ec204e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec204e1",
  null
  
)

export default component.exports